import { Injectable } from "@angular/core";
import { DwContextDefinition, DwCustomContextBase, DwCustomContextDefinition, DwUserEntity } from "@devwareapps/devware-cap";
import { AppMetaDataItemNames, PilotExaminerEntity } from "../../../meta-data/app-meta-data.service";

@DwCustomContextDefinition({
    keyName: 'examinerSettingsContext',
    display: 'Examiner Settings Context',
    isGlobal: false,
    parentItem: AppMetaDataItemNames.DwUser,
})
@Injectable()
export class ExaminerSettingsContextService extends DwCustomContextBase {

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext => {
            const user = resolvedContext?.data as any;

            const pilotExaminer : PilotExaminerEntity = user?.PilotExaminer;

            return pilotExaminer;

        });

        contextDef.item = AppMetaDataItemNames.PilotExaminer;
        contextDef.useItemMetaData = true;
    }

}